import React from 'react';
import ChannelDetailPage from './ChannelDetailPage';

const ChannelsManaPoolPage: React.FC = () => {
  return <ChannelDetailPage channelName="manapool" />;
};

export default ChannelsManaPoolPage;
